import { Form } from 'antd';

import TagSelect from '@/components/TagSelect';

import { OptionInterface, TagSelectTplType } from '../types/tplTypes';

export const TagSelectTpl = ({ data }: { data: TagSelectTplType }) => {
  const key = data.valueField || 'key';
  const label = data.labelField || 'value';

  return (
    <Form.Item
      name={data.id}
      label={data?.label}
      {...(data.formItemProps || {})}
    >
      <TagSelect {...(data.componentProps || {})}>
        {data.options.map((item: OptionInterface) => {
          return (
            <TagSelect.Option key={item[key]} value={item[key]}>
              {item[label]}
            </TagSelect.Option>
          );
        })}
      </TagSelect>
    </Form.Item>
  );
};
